/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Notebook
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define('notebook/WSNotebookView', [ 'notebook/bundles/wsNotebook.min' ], entry => entry.WSNotebookView);

define('notebook/bundles/wsNotebook.bridge', () => {});
